import { createContext, useContext } from 'react';
import { Instance, IAnyModelType } from 'mobx-state-tree';
import { create } from 'lib/debug';
const log = create('store');

const createStore = <T extends IAnyModelType>(Model: T, initialState: any) => {
  type IStore = Instance<T>;
  log('createStore', Model.name, initialState);
  let store = Model.create(initialState);

  let StoreContext = createContext(null);

  if (typeof window !== 'undefined') {
    window['__' + Model.name] = store;
  }

  // onSnapshot(store, (snapshot) => {
  //   log(`${Model.name} Snapshot:`, snapshot);
  // });

  let useStore = (): IStore => {
    let _store = useContext(StoreContext);
    // console.log('useStore', _store)
    if (_store === null) {
      throw new Error(
        `${Model.name} Store cannot be null, please add a context provider`,
      );
    }
    return _store;
  };

  const withStore = (Component: React.FC<any>) => {
    return (props: any) => {
      return (
        <StoreContext.Provider value={store}>
          <Component {...props} />
        </StoreContext.Provider>
      );
    };
  };

  return {
    store,
    Provider: StoreContext.Provider,
    useStore,
    withStore,
  };
};

export default createStore;
